import box from './box';
import apply from './apply';

const approval = [
  {
    path: '/approval/apply',
    component: () => import('@/page/approval/Apply.vue'),
    redirect: '/approval/apply/allmenu',
    children: [...apply],
    meta: {
      name: '결재 신청',
      isMenu: true,
      isActive: false,
      isBread: true,
    },
  },
  {
    path: '/approval/box',
    component: () => import('@/page/approval/Box.vue'),
    redirect: '/approval/box/applied',
    children: [...box],
    meta: {
      name: '결재함',
      isMenu: false,
      isActive: false,
      isBread: true,
    },
  },
  {
    path: '/approval/setLine',
    component: () => import('@/page/approval/SetLine.vue'),
    meta: {
      name: '결재라인 설정',
      isActive: false,
      isBread: true,
    },
  },
];

export default approval;
